import { get, post } from "utils/request";
import type {
  ApiResponse,
  User,
  LoginRequest,
  RegisterRequest,
  SystemInfo,
  EmailExistsResponse,
  LoginResponse,
} from "types/api";

/**
 * 发送邮箱验证码
 * @param email 邮箱地址
 */
export const sendEmailCode = (email: string): Promise<ApiResponse<void>> => {
  return get<void>("/email/sendRegion", { email });
};

/**
 * 检查邮箱是否已存在
 * @param email 邮箱地址
 */
export const checkEmailExists = (
  email: string,
): Promise<ApiResponse<EmailExistsResponse>> => {
  return get<EmailExistsResponse>("/email/exist", { email });
};

/**
 * 用户注册
 * @param data 注册信息
 */
export const register = (data: RegisterRequest): Promise<ApiResponse<User>> => {
  return post<User>("/System/register", data);
};

/**
 * 用户登录
 * @param data 登录信息
 */
export const login = (
  data: LoginRequest,
): Promise<ApiResponse<LoginResponse>> => {
  return post<LoginResponse>("/System/login", data);
};

/**
 * 获取系统信息
 */
export const getSystemInfo = (): Promise<ApiResponse<SystemInfo>> => {
  return get<SystemInfo>("/System/sysInfo");
};

// 保持向后兼容的导出（可选）
export const getEmailCode = sendEmailCode;
export const getExist = checkEmailExists;
export const sysRegister = register;
export const sysLogin = login;
export const sysInfo = getSystemInfo;
